import { get, post } from './requests'

export const getPublicCourse = key => slug => get(['new', 'public', 'courses', slug], { key })

export const subscribeToCourse = (slug, payload) =>
  post(['public', 'courses', slug, 'subscribe'], {}, payload)
